import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { IBitfDialog } from '@interfaces';

@Injectable({
  providedIn: 'root',
})
export class DialogsService {
  public dialog: IBitfDialog;
  constructor(public matDialog: MatDialog) {
    this.dialog = matDialog;
  }
}
